import { render, staticRenderFns } from "./CouponInfo.vue?vue&type=template&id=06cdc170&scoped=true"
import script from "./CouponInfo.vue?vue&type=script&lang=ts"
export * from "./CouponInfo.vue?vue&type=script&lang=ts"
import style0 from "./CouponInfo.vue?vue&type=style&index=0&id=06cdc170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cdc170",
  null
  
)

export default component.exports